"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Card = _interopRequireDefault(require("./Card.style"));
var _CardTitle = _interopRequireDefault(require("./CardTitle"));
var _Caption = _interopRequireDefault(require("./Caption"));
var _CustomMenuList = _interopRequireDefault(require("../misc/CustomMenuList"));
var _excluded = ["title", "customTitle", "subtitle", "titleProps", "delimiterProps", "children", "caption", "captionPosition", "link", "cta", "contextualMenu"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var renderCaption = function renderCaption(caption, captionPosition, otherProps) {
  if (captionPosition === 'both') {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Caption["default"], _extends({
      caption: caption
    }, otherProps, {
      captionPosition: "top"
    })), /*#__PURE__*/_react["default"].createElement(_Caption["default"], _extends({
      caption: caption
    }, otherProps, {
      captionPosition: "bottom-card"
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_Caption["default"], _extends({
    caption: caption
  }, otherProps, {
    captionPosition: captionPosition === 'top' ? 'top' : 'bottom-card'
  }));
};
var Card = function Card(_ref) {
  var title = _ref.title,
    customTitle = _ref.customTitle,
    subtitle = _ref.subtitle,
    titleProps = _ref.titleProps,
    delimiterProps = _ref.delimiterProps,
    children = _ref.children,
    caption = _ref.caption,
    captionPosition = _ref.captionPosition,
    link = _ref.link,
    cta = _ref.cta,
    contextualMenu = _ref.contextualMenu,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], _extends({
    cta: cta,
    captionPosition: captionPosition
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-header"
  }, contextualMenu && /*#__PURE__*/_react["default"].createElement(_CustomMenuList["default"], {
    menuConfig: contextualMenu,
    className: "contextual-menu"
  }), title && /*#__PURE__*/_react["default"].createElement(_CardTitle["default"], _extends({
    className: "card-title",
    title: title,
    titleProps: titleProps,
    delimiterProps: delimiterProps,
    withSubtitle: !(0, _utils.isBlank)(subtitle)
  }, otherProps)), customTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-title"
  }, customTitle)), link && /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-link"
  }, link), subtitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-subtitle"
  }, subtitle), children, cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-cta"
  }, cta), caption && renderCaption(caption, captionPosition, otherProps));
};
Card.defaultProps = {
  className: 'Card',
  title: '',
  subtitle: '',
  caption: '',
  children: undefined,
  titleProps: {
    id: '',
    titleFontSize: '',
    isBold: true,
    isUppercase: false,
    textTransform: 'capitalize'
  },
  delimiterProps: {
    titleDelimiter: false,
    position: 'left',
    topMargin: '',
    type: 'small'
  },
  link: '',
  cta: undefined,
  captionPosition: 'bottom',
  contextualMenu: '',
  customTitle: ''
};
Card.propTypes = {
  captionPosition: _propTypes["default"].oneOf(['top', 'bottom', 'both']),
  className: _propTypes["default"].string,
  /* The card cta button(or whatever) */
  cta: _propTypes["default"].node,
  /** Text or html to be displayed inside the card */
  children: _propTypes["default"].node,
  /**
   * A text to be displayed at the bottom of the card containing some captions
   * (eg. required fields)
   * */
  caption: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** A text to be displayed as the card title */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** Attributes for the card title */
  titleProps: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    titleFontSize: _propTypes["default"].string,
    isBold: _propTypes["default"].bool,
    isUppercase: _propTypes["default"].bool,
    textTransform: _propTypes["default"].oneOf(['none', 'capitalize', 'uppercase', 'lowercase'])
  }),
  /** Attributes for the delimiter */
  delimiterProps: _propTypes["default"].shape({
    titleDelimiter: _propTypes["default"].bool,
    position: _propTypes["default"].string,
    topMargin: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['small', 'medium'])
  }),
  /** A text to be displayed as the card subtitle */
  subtitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /* The card link button */
  link: _propTypes["default"].node,
  contextualMenu: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].arrayOf(_propTypes["default"].shape({})), _propTypes["default"].node]),
  customTitle: _propTypes["default"].node
};
var _default = exports["default"] = Card;